// FF stands for Feature Flag
export const FF_PEN_TOOL_INTRO = 'pen-tool-intro';
export const FF_OLOAPTEEKKI_FONTS = 'oloapteekki-fonts'; // DO NOT REMOVE
export const FF_HYPERGRYPH_FONTS = 'hypergryph-fonts'; // DO NOT REMOVE
export const FF_VARIANT_TEST = 'test';

export const FF_NUHIADEMAJ_FONTS = 'nuhiademaj-fonts'; // DO NOT REMOVE
export const FF_ALKO_FONTS = 'alko-fonts'; // DO NOT REMOVE
export const FF_SUPER_FONTS = 'super-fonts'; // DO NOT REMOVE
export const FF_ROTHO_FONTS = 'rotho-fonts'; // DO NOT REMOVE
export const FF_KPAY_GROUP_FONTS = 'kpay-group-fonts'; // DO NOT REMOVE
export const FF_CEPHEID_FONTS = 'cepheid-fonts'; // DO NOT REMOVE
/** Matches the existing backend FeatureFlag.WeaveAgentplat rollout. */
export const FF_WEAVE_AGENTPLAT = 'weave-agentplat';
/** KEEP_IN_SYNC weavy/core/src/shared/feature-flags/feature-flags.enum.ts (FeatureFlag.WeaveSideBySide). */
export const FF_WEAVE_SIDE_BY_SIDE = 'weave-side-by-side';
/**
 * KEEP_IN_SYNC weavy/core/src/shared/feature-flags/feature-flags.enum.ts (FeatureFlag.WorkflowComments). The server
 * decides who sees comments; this only keeps the client from loading them while the flag is off.
 */
export const FF_WORKFLOW_COMMENTS = 'workflow-comments';
export const FF_WEAVE_FILE_FIGMA_CREDITS_CONSUMPTION = 'weave-file-figma-credits-consumption';
export const FF_RECOVER_WAF_CHALLENGES_CROSS_TAB = 'recover-waf-challenges-cross-tab';
export const FF_ECOWORLD_BRANDING_FONTS = 'ecoworld-branding-fonts'; // DO NOT REMOVE

export const FF_INNOCEAN_EUROPE_FONTS = 'innocean-europe-fonts'; // DO NOT REMOVE
/** KEEP_IN_SYNC weavy/core/src/shared/feature-flags/feature-flags.enum.ts (FeatureFlag.SignInTurnstile), which documents it. */
export const FF_SIGNIN_TURNSTILE = 'signin-turnstile';

export const FF_JONASHERMANNS_FONTS = 'jonashermanns-fonts'; // DO NOT REMOVE
export const FF_KINSTA_FONTS = 'kinsta-fonts'; // DO NOT REMOVE
export const FF_RING_FONTS = 'ring-fonts'; // DO NOT REMOVE
export const FF_HIBOB_FONTS = 'hibob-fonts'; // DO NOT REMOVE
export const FF_FIGMA_SANS_FONTS = 'figma-sans-fonts'; // DO NOT REMOVE
export const FF_BEURER_FONTS = 'beurer-fonts'; // DO NOT REMOVE
export const FF_MAAR_FONTS = 'maar-fonts'; // DO NOT REMOVE
export const FF_BONOHEALTH_FONTS = 'bonohealth-fonts'; // DO NOT REMOVE
export const FF_FIGMA_NODE_DISCONNECT = 'figma-node-disconnect';
export const FF_COMPARE_NODE_FULLSCREEN = 'compare-node-fullscreen';
/** KEEP_IN_SYNC weavy/core/src/shared/feature-flags/feature-flags.enum.ts (FeatureFlag.PromptVoiceInput), which documents it. */
export const FF_PROMPT_VOICE_INPUT = 'prompt-voice-input';
export const FF_FIGMA_FILE_METADATA_SCOPE = 'figma-file-metadata-scope';
export const FF_WEAVE_API_KEYS = 'external-api-keys-ui';
export const FF_WEAVE_API_TERMS_GATE = 'external-api-terms-gate';
export const FF_ALEPH_FONTS = 'aleph-fonts'; // DO NOT REMOVE
export const FF_RAKUTEN_FONTS = 'rakuten-fonts'; // DO NOT REMOVE
export const FF_SCRIBOS_FONTS = 'scribos-fonts'; // DO NOT REMOVE
export const FF_DEPOSCO_FONTS = 'deposco-fonts'; // DO NOT REMOVE
export const FF_EMPIK_FONTS = 'empik-fonts'; // DO NOT REMOVE
export const FF_BARKBOX_FONTS = 'barkbox-fonts'; // DO NOT REMOVE
export const FF_KOMFI_FONTS = 'komfi-health-fonts'; // DO NOT REMOVE
export const FF_VMFOOTWEAR_FONTS = 'vmfootwear-fonts'; // DO NOT REMOVE
export const FF_JOURNEYFURTHER_FONTS = 'journeyfurther-fonts'; // DO NOT REMOVE
export const FF_NOBEARS_FONTS = 'nobears-fonts'; // DO NOT REMOVE
export const FF_NVIDIA_FONTS = 'nvidia-fonts'; // DO NOT REMOVE
export const FF_OPERA_FONTS = 'opera-fonts'; // DO NOT REMOVE
export const FF_SAMURAI_FONTS = 'samur-ai-fonts'; // DO NOT REMOVE
export const FF_VOLVO_FONTS = 'volvo-fonts'; // DO NOT REMOVE
export const FF_SAMY_FONTS = 'samy-fonts'; // DO NOT REMOVE
export const FF_BUSUU_FONTS = 'busuu-fonts'; // DO NOT REMOVE
export const FF_SPAFAX_FONTS = 'spafax-fonts'; // DO NOT REMOVE
export const FF_TEAM5PM_FONTS = 'team5pm-fonts'; // DO NOT REMOVE
export const FF_LLBEAN_FONTS = 'llbean-fonts'; // DO NOT REMOVE
export const FF_A16Z_FONTS = 'a16z-fonts'; // DO NOT REMOVE
export const FF_PUNKLE_FONTS = 'punkle-fonts'; // DO NOT REMOVE
export const FF_PREDATOR_GROUP_FONTS = 'predator-group-fonts'; // DO NOT REMOVE
export const FF_STRATEYRANT_FONTS = 'strategyrant-fonts'; // DO NOT REMOVE
export const FF_DUNLOP_FONTS = 'dunlop-fonts'; // DO NOT REMOVE
export const FF_AND_OR_FONTS = 'and-or-fonts'; // DO NOT REMOVE
export const FF_LINDEX_FONTS = 'lindex-fonts'; // DO NOT REMOVE
export const FF_JAN_GERICKE_FONTS = 'jan-gericke-fonts'; // DO NOT REMOVE
export const FF_METROPOLIS_FONTS = 'metropolis-fonts'; // DO NOT REMOVE
export const FF_AROSOLUCIONES_FONTS = 'arosoluciones-fonts'; // DO NOT REMOVE
export const FF_MINTHC_FONTS = 'minthc-fonts'; // DO NOT REMOVE
export const FF_WOLFE_FONTS = 'wolfe-fonts'; // DO NOT REMOVE
export const FF_META_CREATIVE_X_FONTS = 'meta-creative-x-fonts'; // DO NOT REMOVE
export const FF_POLYMATHTEXT_FONTS = 'polymathtext-fonts'; // DO NOT REMOVE
export const FF_JOURNEY_FONTS = 'journey-fonts'; // DO NOT REMOVE
export const FF_ENCENDER_FONTS = 'encender-fonts'; // DO NOT REMOVE
export const FF_WEAVY_TEST_FONTS = 'weavy-test-fonts'; // DO NOT REMOVE
export const FF_EUCLID_SQUARE_FONTS = 'euclid-square-fonts'; // DO NOT REMOVE
export const FF_OPG_FONTS = 'opg-fonts'; // DO NOT REMOVE
export const FF_OUTBREAKER_FONTS = 'outbreaker-fonts'; // DO NOT REMOVE
export const FF_VIRGIN_SCRIPTY_FONTS = 'virgin-scripty-fonts'; // DO NOT REMOVE
export const FF_VACIER_FONTS = 'vacier-fonts'; // DO NOT REMOVE
export const FF_45AI_FONTS = '45ai-fonts'; // DO NOT REMOVE
export const FF_UROSKRA77_FONTS = 'uroskra77-fonts'; // DO NOT REMOVE
export const FF_STAPLES_FONTS = 'staples-fonts'; // DO NOT REMOVE
export const FF_CHRISTHORPE1_FONTS = 'christhorpe1-fonts'; // DO NOT REMOVE
export const FF_OSTRACON_FONTS = 'ostracon-fonts'; // DO NOT REMOVE
export const FF_GOODSTUPH_FONTS = 'goodstuph-fonts'; // DO NOT REMOVE
export const FF_OMRE_FONTS = 'omre-fonts'; // DO NOT REMOVE
export const FF_CAPGEMINI_FONTS = 'capgemini-fonts'; // DO NOT REMOVE
export const FF_OLIVER_OLEJAR_FONTS = 'oliver-olejar-fonts'; // DO NOT REMOVE
export const FF_OLIVER_WYMAN_FONTS = 'oliver-wyman-fonts'; // DO NOT REMOVE
export const FF_TREZION_FONTS = 'trezion-fonts'; // DO NOT REMOVE
export const FF_OPG_PLUS_FONTS = 'opg-plus-fonts'; // DO NOT REMOVE
export const FF_DELIVEROO_FONTS = 'deliveroo-fonts'; // DO NOT REMOVE
export const FF_WOLF_KASH_FONTS = 'wolf-kash-fonts'; // DO NOT REMOVE
export const FF_COINSHARES_FONTS = 'coinshares-fonts'; // DO NOT REMOVE
export const FF_AMAZON_JP_FONTS = 'amazon-jp-fonts'; // DO NOT REMOVE
export const FF_HOT_DESK_FONTS = 'hot-desk-fonts'; // DO NOT REMOVE
export const FF_PLURITY_FONTS = 'plurity-fonts'; // DO NOT REMOVE
export const FF_LIBRIO_FONTS = 'librio-fonts'; // DO NOT REMOVE
export const FF_WALLACHMATTHEW_FONTS = 'wallachmatthew-fonts'; // DO NOT REMOVE
export const FF_S_B_FONTS = 's-b-fonts'; // DO NOT REMOVE
export const FF_ADVANCEGROUP_FONTS = 'advancegroup-fonts'; // DO NOT REMOVE
export const FF_365SCORES_FONTS = '365scores-fonts'; // DO NOT REMOVE
export const FF_SPECIALGROUP_FONTS = 'specialgroup-fonts'; // DO NOT REMOVE
export const FF_TASKFORCE_FONTS = 'taskforce-fonts'; // DO NOT REMOVE
export const FF_CHEIL_FONTS = 'cheil-fonts'; // DO NOT REMOVE
export const FF_WILLHABEN_FONTS = 'willhaben-fonts'; // DO NOT REMOVE
export const FF_FORD_FONTS = 'ford-fonts'; // DO NOT REMOVE
export const FF_HOLIDAY_PROMO_BANNER = 'holiday-promo-banner'; // DO NOT REMOVE - for displaying a promo banner on the pricing page and pricing modal
export const FF_REMOVE_FROM_GROUP_WITH_MODIFIER = 'remove-from-group-with-modifier';
export const FF_CLIENT_OLD_VERSION_RELOAD = 'client-old-version-reload'; // DO NOT REMOVE
export const FF_SOCKET_RECONNECTION_ISSUE = 'socket-reconnection-issue';
export const FF_LOG_SOCKET_EVENTS = 'client-log-socket-events'; // DO NOT REMOVE
/** Polls this workflow's unfinished batches that the page rehydrates after a reload, and aborts
 *  status requests still in flight when the workflow is left. Off: only runs started on this page
 *  are polled. */
export const FF_RESUME_BATCH_POLLING = 'resume-batch-polling';
export const FF_SWIPE_TO_DELETE_EDGE = 'swipe-to-delete-edge';
export const FF_PROXIMITY_CONNECT = 'proximity-connect';
/** Gates fitting the compositor timeline to its content range. */
export const FF_COMPOSITOR_FIT_TO_CONTENT = 'compositor-fit-to-content';
export const FF_COMPOSITOR_SIMPLE_SHAPES = 'compositor-simple-shapes';
export const FF_COMPOSITOR_MASKING = 'compositor-masking';
export const FF_CREATE_TEXT_LAYERS = 'create-text-layers';
export const FF_COMPOSITOR_AI_ACTIONS = 'compositor-ai-actions';
export const FF_COMPOSITOR_AI_ACTIONS_OUTPAINT = 'compositor-ai-actions-outpaint';
// Bring your own content into the compositor: the image tool, pasting an image, and the drop
// zone in the designer. It gates only that UI. How a compositor stores what it holds is not
// behind this or any other flag, because two people editing one workflow would then save it in
// different shapes depending on who saved last.
export const FF_COMPOSITOR_SEPARATE_RESOURCES = 'compositor-separate-resources';
// kept apart from the flag above, so upload can be turned on without the panel
export const FF_COMPOSITOR_ASSETS_PANEL = 'compositor-assets-panel';
export const FF_MATRIX_ITERATION_MODE = 'matrix-iteration-mode';
/** Client-side POC gate: exposes Camera in the add-node menu. Existing Camera nodes still render. */
export const FF_CAMERA_NODE_POC = 'camera-node-poc';
/** Gates Figma Node clipboard paste + Linked accounts visibility for that path. */
export const FF_WEAVE_FIGMA_NODE = 'weave-figma-node';
export const FF_STICKY_NOTE_TOOLBAR = 'weave-sticky-note-toolbar';
export const FF_NANO_BANANA_PRO_ERRORS = 'nano-banana-pro-errors';
export const FF_NANO_BANANA_21 = 'nano-banana-2-1';
export const FF_CHIRP_3_TRANSCRIPTION = 'chirp-3-transcription'; // Gates the Chirp 3 transcription (STT) model
export const FF_UMG_BLOCKED_ANY_LLM_MODELS = 'umg-blocked-any-llm-models'; // Blocked any llm models for UMG - Universal Music Group
/** Gates the "Enhance Prompt" checkbox on Seedance ref-to-video (WEA-5475). */
export const FF_PROMPT_ENHANCEMENT = 'prompt-enhancement';
export const FF_DISABLE_SHARE_FOR_FREE_USERS = 'disable-share-for-free-users';
/** Multivariate experiment variant: only this value disables share for free users; all others = control (default). */
export const FF_DISABLE_SHARE_FOR_FREE_USERS_VARIANT_TEST = 'test';
export const FF_SUBFLOWS_SAVED_NODES = 'subflows-saved-nodes';
/** Figma-embed saved library, on top of {@link FF_SUBFLOWS_SAVED_NODES}. Embed saves are personal
 *  (`createdBy`-scoped server-side); standalone stays workspace-shared. */
export const FF_WEAVE_EMBED_SAVED_SUBFLOWS = 'weave-embed-saved-subflows';
/**
 * Re-enables the inline "Save model to my library" button (and its save dialog) on imported-model
 * nodes. This action was removed for all sessions in #811127 (which disabled subflow-template sharing
 * in Figma-embedded files); this opt-in flag brings the button and its logic back per user.
 */
export const FF_SAVE_MODEL_TO_LIBRARY_BUTTON = 'save-model-to-library-button';
/** Shift+Backspace/Delete removes selected nodes but bridges edges across the gap. */
export const FF_SHIFT_DELETE_DELETE_AND_KEEP_SELECTION = 'shift-delete-to-delete-and-keep-selection';
export const FF_CUSTOM_GLSL_PRICING = 'custom-effect-glsl-pricing';
export const FF_CUSTOM_EFFECT_IMAGE_REFERENCES = 'custom-effect-image-references';
export const FF_CUSTOM_EFFECT_NO_INPUT = 'custom-effect-no-input';
export const FF_RUNWAY_ALEPH2 = 'runway-aleph2';
export const FF_KLING_V4_FLASH = 'kling-v4-flash';
export const FF_SHARE_ASSET_VIEW_REDESIGN = 'share-asset-view-redesign';
export const FF_WORKFLOW_APP_BUILDER_MODE = 'workflow-app-builder-mode';
export const FF_WORKSPACE_CUSTOM_FONTS = 'workspace-custom-fonts';
/**
 * Gates the WASM dynamic custom-font engine path (family→cut catalog pushed via `setCustomFonts`).
 * Layered on top of {@link FF_WORKSPACE_CUSTOM_FONTS} so the engine render path ramps independently.
 * Font pickers must require this flag before offering custom families — otherwise a selection
 * renders as the DMSans fallback with empty weight/style options.
 */
export const FF_WORKSPACE_CUSTOM_FONTS_WASM = 'workspace-custom-fonts-wasm';
/**
 * Serves company fonts from the DB/presigned-URL path (like custom fonts) instead of static
 * `/fonts/` files. When off, company fonts load statically as before. Independent of
 * {@link FF_WORKSPACE_CUSTOM_FONTS} so the company-font migration can roll out on its own.
 */
export const FF_COMPANY_FONTS_FROM_DB = 'company-fonts-from-db';
export const FF_WORKSPACE_CUSTOM_FONTS_DASHBOARD_PAGE = 'workspace-custom-fonts-dashboard-page';
export const FF_FIGMA_OAUTH_CONNECT = 'figma-oauth-connect';
/** Payload (number of seconds) controlling how often the Figma node polls for upstream edits. Defaults to 5s. */
export const FF_FIGMA_NODE_POLL_INTERVAL_SECONDS = 'figma-node-poll-interval-seconds';
export const FF_WORKFLOW_COMMUNITY_PUBLISHING = 'workflow-community-publishing';
/** Gates the rollout for publishing Weave tools to Figma organizations. */
export const FF_FIGMA_ORG_SCOPED_PUBLISHING = 'figma-org-scoped-publishing';
export const FF_WORKFLOW_COMMUNITY_PUBLISHING_WEAVE_CATEGORY_ALLOWLIST =
  'workflow-community-publishing-weave-category-allowlist';
/** Gates the "Publish to Community" panel in the tool Share modal (App View Separation), so the
 *  tool-publish entrypoint can roll out independently of workflow community publishing. */
export const FF_TOOL_COMMUNITY_PUBLISHING = 'tool-community-publishing';
/** Exposes the hidden-tool Community category in the tool publish picker. Tools filed under it are
 *  not viewable in Community, so it's an internal publishing lane. */
export const FF_TOOL_COMMUNITY_PUBLISHING_HIDDEN_CATEGORY = 'tool-community-publishing-hidden-category';
export const FF_FIGMA_THEME = 'figma-theme';
export const FF_FPL_MIGRATION = 'fpl-migration';
/** Offers the light/dark mode preference. Off → the app renders dark unconditionally, matching
 *  today's appearance regardless of any stored preference. */
export const FF_LIGHT_MODE = 'light-mode';
/** Moves the Enterprise package into the pricing-plan card grid. */
export const FF_WEAVE_PLAN_OVERVIEW_ENTERPRISE_CARD = 'weave-plan-overview-enterprise-card';
/** Shared with the backend to gate the Max tier rollout. */
export const FF_WEAVE_MAX_TIER = 'weave-max-tier';
/** Independently hides Max pricing; the shared Max rollout flag must also be enabled. */
export const FF_WEAVE_MAX_TIER_FRONTEND = 'weave-max-tier-frontend';
/** Periodically auto-generates and uploads a thumbnail of the current workflow as its poster. */
export const FF_WORKFLOW_AUTO_THUMBNAIL_ENABLED = 'workflow-auto-thumbnail-enabled';
export const FF_CREDITS_ALL_TIME_EXPORT = 'credits-all-time-export';
export const FF_CUSTOM_MODEL_APPROVAL = 'import-custom-model-enterprise';
/** Gates availability emails and their notification toggle. Default off; roll out globally at 0% or 100%. */
export const FF_VERIFIED_MODEL_AVAILABILITY_EMAILS = 'verified-model-availability-emails';
/** Recipe Version History drawer + snapshot preview/restore/save-as-new flow. */
export const FF_RECIPE_VERSION_HISTORY = 'recipe-version-history';
/** Multi-node connect: drag a handle from one selected node to fan out edges from every selected node's matching-type handle. */
export const FF_MULTI_CONNECT_FROM_SELECTION = 'multi-connect-from-selection';
/** Strips control chars / zero-width chars / whitespace from pasted model
 *  identifiers in ImportModelView; mirrored server-side as a defensive retry
 *  in model-price lookup. */
export const FF_NORMALIZE_IMPORTED_MODEL_NAMES = 'normalize-imported-model-names';
/** Master flag for App View Separation: the standalone /tool/:toolId page (view/run/share). Must
 *  match the backend flag string exactly. */
export const FF_APP_VIEW_SEPARATION = 'app-view-separation';
/** Gates the tool view redesign, starting with the title bar and sidebar toggle. */
export const FF_WEAVE_TOOL_VIEW_REDESIGN = 'weave-tool-view-redesign';
/** Shared rollout for mobile tool routes and layout. Enable once the mobile page is ready. */
export const FF_WEAVE_TOOLS_MOBILE = 'weave-tools-mobile';
/** The dashboard's unified workflow/tool list: one "Shared with me" holding both kinds, per-row
 *  labels, and the tab strip, in place of the separate "Tools" section. Requires app-view-separation
 *  and must match the backend flag string exactly. */
export const FF_DASHBOARD_TOOL_TABS = 'dashboard-tool-tabs';
/** Experiment (WEA-7117): drag a thumbnail out of the full screen gallery to add it to the canvas as a new node. */
export const FF_GALLERY_DRAG_TO_CANVAS = 'gallery-drag-to-canvas';
/** Shows the onboarding template gallery the first time a new user lands on an empty workflow. */
export const FF_ONBOARDING_TEMPLATE_GALLERY = 'onboarding-template-gallery';
export const FF_MOBILE_SIGNUP_HANDOFF = 'mobile-signup-handoff';
/** Lets mobile devices open the generator (`/generate`) and the tools catalog instead of the mobile
 *  unsupported page. */
export const FF_MOBILE_GENERATOR_AND_CATALOG = 'mobile-catalog';
/** Optional override for the Meet Weave welcome-modal artwork. JSON payload `{ videoUrl?, posterUrl? }`
 *  (https URLs) lets the clip be swapped via the PostHog dashboard without a release; falls back to the
 *  bundled asset when unset. See `components/WelcomeModal/meetWeaveMedia.ts`. */
export const FF_MEET_WEAVE_MODAL_MEDIA = 'meet-weave-modal-media';
/** Blocks Free-plan users from importing/running custom (imported) models. Must match the backend
 *  `BlockFreeUserModelImport` flag string exactly. */
export const FF_BLOCK_FREE_USER_MODEL_IMPORT = 'block-free-user-model-import';
/** Blocks Free-plan users from running video models (nodes stay visible in the menu — only the run is
 *  blocked). Must match the backend `BlockFreeUserVideoModel` flag string exactly. */
export const FF_BLOCK_FREE_USER_VIDEO_MODEL = 'block-free-user-video-model';
/** Blocks Free-plan users from running the models in `FREE_PLAN_BLOCKED_MODELS`. Must match the backend
 *  `BlockFreeUserModels` flag string exactly. */
export const FF_BLOCK_FREE_USER_MODELS = 'block-free-user-models';
/** Experiment: full pricing with annual billing versus a focused video Starter paywall with monthly billing. */
export const FF_VIDEO_PAYWALL_STARTER_MONTHLY_PAYMENT_DEFAULT = 'video-paywall-starter-monthly-payment-default';
export const FF_BLOCK_FREE_USER_CUSTOM_EFFECT = 'block-free-user-custom-effect';
/** Gates the first-month subscription-discount campaign on the pricing page. Must match the backend
 *  `SubscriptionDiscountPromo` flag string exactly. A global on/off switch, never a partial rollout:
 *  the server evaluates it against one constant distinct id. The payload is read only by the server;
 *  the advertised amounts are fixed per plan and live in `PricingPackage`. */
export const FF_SUBSCRIPTION_DISCOUNT_PROMO = 'discount_first_month_off_08_2026';
/** Gates the Enterprise upgrade-button experiment for eligible dashboard left-rail users. */
export const FF_UNIVERSAL_UPGRADE_BUTTON_ENTERPRISE = 'universal-upgrade-button-enterprise';
/** Remote-config payload of model-price promotions. Must match the backend `ModelPricePromotions` flag string. */
export const FF_MODEL_PRICE_PROMOTIONS = 'model-price-promotions';
/** Paid-audience promotions. Mirrors PROMOTION_FLAGS on the server — both are read and merged. */
export const FF_MODEL_PRICE_PROMOTIONS_PAID = 'model-price-promotions-paid';
/** Max promotions, targeted by plan and subscriptionStartsAt in PostHog. */
export const FF_MODEL_PRICE_PROMOTIONS_MAX_TIER = 'model-price-promotions-max-tier';
/** Gates Cut (Cmd/Ctrl+X) for canvas nodes: copy the selection to the clipboard, then delete it. */
export const FF_CUT_NODES = 'cut-nodes';
/** Adds the Align submenu (align / distribute / auto-arrange) to the canvas multi-selection menu. */
export const FF_ALIGN_NODES = 'align-nodes';
/** Gates the Volume slider control in the compositor Layer Property Panel for audio/video layers. */
export const FF_COMPOSITOR_LAYER_VOLUME = 'compositor-layer-volume';
/** Gates the temporary fade in/out controls in the compositor Layer Property Panel. */
export const FF_COMPOSITOR_ANIMATION_FADE = 'compositor-animation-fade';
/** Gates converting compositor image layers to shapes with image fills. */
export const FF_COMPOSITOR_4_CORNER_PIN = 'compositor-4-corner-pin';
/** Gates the stroke section and optional (removable) fill in the compositor Layer Property Panel.
 *  Off: shapes keep the legacy always-present fill color row and have no stroke controls. */
export const FF_COMPOSITOR_STROKE_AND_FILL_OPTION = 'compositor-stroke-and-fill-option';
/** Gates the Distribution section (distribute vertical/horizontal spacing) in the compositor Layer Property Panel. */
export const FF_COMPOSITOR_DISTRIBUTE_LAYERS = 'compositor-distribute-layers';
/** Enables grouping/ungrouping compositor layers (Cmd/Ctrl+G and Cmd/Ctrl+Shift+G). */
export const FF_GROUP_LAYERS = 'group-layers';
/** Duplicate and copy/paste of compositor layers (Cmd/Ctrl+D, Cmd/Ctrl+C, Cmd/Ctrl+V and the layer
 *  menu items). Only a layer that owns its content can be reused, so with every content flag off
 *  there is nothing to act on and the menu items stay greyed out. */
export const FF_COMPOSITOR_DUPLICATE_PASTE = 'compositor-duplicate-paste';
/** Gates bringing owned video/audio into the compositor through the picker, drag/drop, and
 *  duplicate/copy-paste. Connected media nodes and clips already in a composition are unaffected. */
export const FF_COMPOSITOR_VIDEO_AUDIO_INSERT = 'compositor-video-audio-insert';
/** Routes compositor audio playback through the Rust/WASM audio engine instead of the
 *  `useAudioPlayback` HTMLAudioElement hook. Off: byte-identical to the hook (no AudioContext
 *  is created). See useAudioEngine and design-core `web/src/audio.rs`. */
export const FF_COMPOSITOR_AUDIO_ENGINE = 'compositor-audio-engine';
/** Holds the wasm video playhead until visible media is ready (`readyState >= 2`).
 *  Must match design-core `CHECK_VISIBLE_MEDIA_CAN_PLAY`. Off (default): clock
 *  advances even if elements have not loaded. */
export const FF_CHECK_VISIBLE_MEDIA_CAN_PLAY = 'check-visible-media-can-play';
/** Direct-load optimization for dropped 3D models (incl. gaussian splat .ply files): render
 *  the in-memory bytes immediately while the CDN upload runs in the background, then re-key to
 *  the CDN url — avoiding the upload-then-download round-trip. See useLocalDirectLoadHandlers. */
export const FF_LOCAL_3D_DIRECT_LOAD = 'local-3d-direct-load';
/** Gates prompt-node version history capture. Must match the backend `prompt-node-history` flag exactly. */
export const FF_PROMPT_NODE_HISTORY = 'prompt-node-history';
/** Weavy→Figma AI credit conversion ratio (remote config, bare-number payload). Read via
 *  {@link useWeavyToFigmaCredits}; falls back to the bundled default when absent. Must match the
 *  backend `WeaveFigmaCreditRatio` flag exactly so the credits shown match the cost charged. */
export const FF_WEAVE_FIGMA_CREDIT_RATIO = 'weave-figma-credit-ratio';
export const FF_WEAVE_MCP_LINK_ACCOUNT = 'weave-mcp-link-account';
/** Sends a user who just signed up into a new empty workflow instead of the file browser, so the
 *  onboarding has somewhere to run. Read once during sign in, see getNewUserLanding. */
export const FF_NEW_USER_WORKFLOW_LANDING = 'new-user-workflow-landing';
/** Gates corner resize on import / model / media-iterator nodes (WEA-3923). */
export const FF_NODE_DIAGONAL_RESIZE = 'node-diagonal-resize';
/** Client-side only. Shows the one-time marketing consent modal for eligible users. */
export const FF_MARKETING_CONSENT = 'marketing-consent';
/** Whether the standalone tool pages are open. Read by `apps/src/access.ts`, which sends a visitor to
 *  the app when this is off. Answers for the pages as a group: there is one page today, and a second
 *  one that has to open on its own day gets its own flag. Released to Figma people only while the pages
 *  are not public, so a visitor PostHog cannot place is sent to the app too.
 *  Also shows the dashboard's Toolkit and opens the `/generate` page it links to. Those only read whether
 *  the flag is on, not the `live` list. */
export const FF_TOOLS_CATALOG = 'tools-catalog';
/**
 * Kill-switch for WEA-6449: skip GPU input snapshots and strip data-URLs on POST /cost.
 * Defaults on when the flag is missing; set 0% in PostHog (or `featureFlagsOff=`) to revert.
 */
export const FF_LIGHTWEIGHT_BATCH_COST = 'lightweight-batch-cost';
export const FF_EXPORT_WORKFLOW_LINEAGE = 'export-workflow-lineage';
/** Enables workflow lineage for enterprise workspaces. The original flag still enables all plans. */
export const FF_EXPORT_WORKFLOW_LINEAGE_ENTERPRISE = 'export-workflow-lineage-enterprise';
/** Gates paywall modal when Free users click the Share Button */
export const FF_SHARE_BUTTON_PAYWALL = 'share-button-paywall';
/**
 * Send one graphic per execute POST as sibling `computedImages` + `image_ref` handles (WEA-6449).
 * Off (default): inline `{ type: image, url }`. The API expands the map whenever it is present and
 * does not read this flag. Enable only after host-once is on the execute path.
 */
export const FF_WEAVE_EXECUTE_COMPUTED_IMAGES = 'weave-execute-computed-images';
/** The Effects section of the compositor's layer property panel: adding, removing, hiding an
 *  effect, and the panel its options are edited in. It gates only that UI. A layer that already
 *  carries effects still draws them with the flag off, so a composition looks the same to
 *  everyone who opens it. */
export const FF_EFFECTS_ON_LAYERS = 'effects-on-layers';
/** Collapses a node's input handles into one group handle per type. Off: the flat list renders. */
export const FF_COLLAPSE_HANDLES_BY_TYPE = 'collapse-handles-by-type';

/** Gates the 30% annual prices and savings labels. Core reads the same flag to charge the new annual
 * prices, so enable it globally only (0% or 100%) to keep the price shown and charged in step.
 * Keep the first-month campaign off until its totals are updated.
 * KEEP_IN_SYNC weavy/core/src/shared/feature-flags/feature-flags.enum.ts (AnnualDiscount30) */
export const FF_ANNUAL_DISCOUNT_30 = 'annual-discount-30';
/** Empty canvas new user experience feature flag */
export const FF_EMPTY_CANVAS = 'empty-canvas';
export const FF_EMPTY_CANVAS_NUX = 'empty-canvas-nux';
/** Hovering a node's run button during a multi-run batch lists each run's progress. */
export const FF_BATCH_RUN_PROGRESS_TOOLTIP = 'batch-run-progress-tooltip';
/** While a run's request is still being sent, the node's Run button says "Uploading" and offers cancel. */
export const FF_RUN_UPLOAD_STATUS = 'run-upload-status';
/** The Assets panel with search, filters, newest first and double-click to go to a node, and its labeled
 *  button in the rail. Off: the old panel and its unlabeled button at the bottom of the rail. */
export const FF_MEDIA_PANEL_V2 = 'media-panel-v2';

/** Adds video concatenation to the canvas selection context menu. */
export const FF_VIDEO_CONCAT_CONTEXT_MENU = 'video-concat-context-menu';

/** Shows the local Scale selector on video concatenation nodes. */
export const FF_VIDEO_CONCAT_SCALE_SELECTOR = 'video-concat-scale-selector';

/** Shows the concat timeline strip in place of the default seek slider. */
export const FF_VIDEO_CONCAT_TIMELINE_STRIP = 'video-concat-timeline-strip';

/** Opt-in diagnostics for deleted model results being replayed. Missing flags remain off. */
export const FF_RESULT_RESURRECTION_DIAGNOSTICS = 'result-resurrection-diagnostics';

/** Hold Shift to lock node dragging to a horizontal or vertical axis. */
export const FF_NODE_AXIS_LOCK = 'node-axis-lock';

/** Forgets every batch when leaving a workflow, so its runs don't linger in the next workflow's task
 *  manager. Off: runs from workflows left behind stay in the batch store until a reload. */
export const FF_CLEAR_BATCHES_ON_WORKFLOW_LEAVE = 'clear-batches-on-workflow-leave';

/** Snap node edges and centers to nearby nodes and show alignment guides. */
export const FF_NODE_ALIGNMENT_GUIDES = 'node-alignment-guides';

/** Protects canvas saves: blocks editing with a refresh banner once consecutive saves keep failing,
 *  and holds saves while a run's results may be missing (a socket drop mid-run, a reload not caught
 *  up yet), re-fetching unfinished batches on each socket connect and blocking once a hold outlasts
 *  its time window. */
export const FF_BLOCK_EDITING_ON_FAILING_SAVES = 'block-editing-on-failing-saves';

/**
 * Observe-mode gate for AI asset marking. Off: downloads never upload the picture. On: the browser sends
 * the picture, and the server logs what it would do when a model node is upstream in the saved workflow.
 */
export const FF_AI_ASSET_MARKING = 'ai_asset_marking';

/**
 * With {@link FF_AI_ASSET_MARKING}, the server signs the picture and the download waits for the signed
 * copy. Off: the picture is still sent to be observed, but the download doesn't wait for it.
 */
export const FF_AI_ASSET_MARKING_SIGN = 'ai_asset_marking_sign';

/** Boots the Intercom Messenger with a backend-signed identity JWT, ahead of Intercom enforcing it. */
export const FF_INTERCOM_IDENTITY_JWT = 'intercom-identity-jwt';
